package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.components.ContactDropdownType
import com.essntl.features.contact.ui.components.ContactsDropDown
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.utils.spacing

@Composable
fun SelectTravelAgentPopup(
    isOpen: Boolean,
    isLoading: Boolean,
    selectedTravelAgent: TravelAgentModel?,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
    onChangeTravelAgent: (TravelAgentModel) -> Unit,
    onDismissRequest: () -> Unit,
) {
    var travelAgent by remember { mutableStateOf(selectedTravelAgent ?: TravelAgentModel.empty) }

    LaunchedEffect(isOpen) {
        if (isOpen) travelAgent = selectedTravelAgent ?: TravelAgentModel.empty
    }

    if (isOpen)
        EsDialog(
            title = "Change travel agent",
            onDismissRequest = onDismissRequest,
        ) {
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.padding(2.5.spacing),
            ) {
                Spacer(modifier = Modifier.height(3.spacing))

                ContactsDropDown(
                    state = contactState,
                    onEvent = contactEvent,
                    type = ContactDropdownType.AGENCY,
                    selectedContact = travelAgent.id,
                    onItemSelected = { id ->
                        travelAgent = TravelAgentModel.empty.copy(id = id)
                    },
                )

                Spacer(modifier = Modifier.height(4.5.spacing))

                EsLargePrimaryButton(
                    text = "Change travel agent",
                    onClick = { onChangeTravelAgent(travelAgent) },
                    enabled = travelAgent != TravelAgentModel.empty,
                    loading = isLoading || contactState.getAllContacts.isLoading,
                    modifier = Modifier.fillMaxWidth(),
                )
            }
        }
}